import { atom } from 'recoil';

export const tabIndexTodayReport = atom<any>({
  key: 'tabIndex',
  default: 0,
});
